import React, { useState } from 'react';
import { IoInformationCircleOutline } from "react-icons/io5";
import EmployeeForm from './EmployeeForm';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const EmployeeNew = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showSingleForm, setShowSingleForm] = useState(true);
    const [showMultipleForm, setShowMultipleForm] = useState(true);
    const [employees, setEmployees] = useState([
        { firstName: '', lastName: '', email: '' },
        { firstName: '', lastName: '', email: '' },
        { firstName: '', lastName: '', email: '' },
    ]);

    const handleEmployeeChange = (index, field, value) => {
        const updatedEmployees = [...employees];
        updatedEmployees[index][field] = value;
        setEmployees(updatedEmployees);
    };

    const addEmployee = () => {
        setEmployees([...employees, { firstName: '', lastName: '', email: '' }]);
    };

    const onSuccess = (employeeId) => {
        console.log('onSuccess employeeId ', employeeId)
        employeeId && navigate('/employees/'+employeeId);
    }

    return (
        <div>
            <div className="flex items-center gap-4 justify-start mb-4">
                <FaArrowLeft className="text-[--color-primary]" />
                <a href="/employees" className="text-[--color-primary]">
                    {t('employeeNew.backToList')}
                </a>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6 mb-6">
                <h1 className='text-3xl font-[700] mb-4'>
                    {t('employeeNew.title')}
                </h1>
                <p className='text-lg text-gray-500 mb-4'>
                    {t('employeeNew.subtitle')}
                </p>

                {/* Bouton pour afficher le formulaire d'un seul employé */}
                <div className='border border-gray-300 rounded-lg p-6 mb-6 flex items-center'>
                    <button
                        onClick={() => setShowSingleForm(!showSingleForm)}
                        className="flex items-center w-full"
                    >
                        <IoInformationCircleOutline className='text-xl' />
                        <div className='ml-2 text-lg font-[500]'>
                            {t('employeeNew.toggleFormLabel')}
                        </div>
                    </button>
                </div>
                {showSingleForm && (
                    <div className="px-20 mb-4 rounded-lg">
                        <EmployeeForm onSuccess={onSuccess} />
                    </div>
                )}

                {/*
                <div className='border border-gray-300 rounded-lg p-6 mb-4 flex items-center'>
                    <button
                        onClick={() => setShowMultipleForm(!showMultipleForm)}
                        className="flex items-center w-full"
                    >
                        <IoInformationCircleOutline className='text-xl' />
                        <div className='ml-2 text-lg font-[500]'>
                            Gagner du temps, vos collaborateurs recevront un mail pour remplir leurs informations
                        </div>
                    </button>
                </div>
                {showMultipleForm && (
                    <div className="p-4">
                        <h2 className="text-xl font-bold mb-4">Formulaire pour plusieurs employés</h2>
                        <form>
                            {employees.map((employee, index) => (
                                <div key={index} className="flex items-center space-x-4 mb-4">
                                    <input
                                        type="text"
                                        placeholder="Prénom"
                                        value={employee.firstName}
                                        onChange={(e) => handleEmployeeChange(index, 'firstName', e.target.value)}
                                        className="border rounded-lg p-2 w-1/3"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Nom"
                                        value={employee.lastName}
                                        onChange={(e) => handleEmployeeChange(index, 'lastName', e.target.value)}
                                        className="border rounded-lg p-2 w-1/3"
                                    />
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        value={employee.email}
                                        onChange={(e) => handleEmployeeChange(index, 'email', e.target.value)}
                                        className="border rounded-lg p-2 w-1/3"
                                    />
                                </div>
                            ))}
                            <button
                                type="button"
                                onClick={addEmployee}
                                className=" text-[--color-primary] font-semibold mb-4"
                            >
                                + Ajouter un collaborateur
                            </button>
                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="bg-[--color-primary] rounded-full text-white px-12 py-2"
                                >
                                    Valider
                                </button>
                            </div>
                        </form>
                    </div>
                )}
                */}
            </div>
        </div>
    );
}

export default EmployeeNew;